export const hospitalDataConstants = {
    FETCH_HOSPITAL_DATA_REQUESTING: "FETCH_HOSPITAL_DATA_REQUESTING",
    FETCH_HOSPITAL_DATA_FETCHED: "FETCH_HOSPITAL_DATA_FETCHED",
    FETCH_HOSPITAL_DATA_FAILED: "FETCH_HOSPITAL_DATA_FAILED",

    SAVE_ACTIVE_CENTRAL_HOSPITAL_DATA :"SAVE_ACTIVE_CENTRAL_HOSPITAL_DATA"
  };
  